import { React } from "react";
import { Card, CardHeader, Nav, NavItem, Row } from "reactstrap";
import { useSelector } from "react-redux";

const Tabs = ({ tabs, selectedTab, onTabChange }) => {
  const { user } = useSelector((state) => state.auth);

  if (tabs.length === 0) {
    return (
      <Card className="shadow py-6 justify-content-center align-items-center">
        You don't have the permission to access the page
      </Card>
    );
  }

  const activeTabContent = tabs.find((tab) => tab.id === selectedTab)?.content;

  return (
    <Row>
      <div className="col">
        {user?.type !== "kitchen-waiter" ? (
          <Card className="shadow overflow-hidden">
            <CardHeader className="p-0 pt-4 d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center">
              <Nav pills>
                {tabs.map((tab) => {
                  const isActive = selectedTab === tab.id;
                  return (
                    <NavItem
                      key={tab.id}
                      className={`text-center cursor-pointer px-4 py-1 ${
                        isActive && "text-primary border-bottom border-primary"
                      }`}
                      onClick={() => onTabChange(tab.id)}
                    >
                      <h3 className={`${isActive && "text-primary"}`}>
                        {tab.name}
                      </h3>
                    </NavItem>
                  );
                })}
              </Nav>
            </CardHeader>

            <div>{activeTabContent}</div>
          </Card>
        ) : (
          //Make a separate card for 
          <>
            <div>{activeTabContent}</div>
          </>
        )}
      </div>
    </Row>
  );
};

export default Tabs;
